import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetInvoices = createAsyncThunk(
  "saleDetails/GetInvoices",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/invoice/list/${id}`);
    return data
  }
);

export const DeleteInvoice = createAsyncThunk(
  "saleDetails/DeleteInvoice",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/invoice/delete/${id}/`)
    return response.status
  }
);

export const GetSaleDetail = createAsyncThunk(
  "saleDetails/GetSaleDetail",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/sale/detail/${id}/`)
    return data
  }
);

export const DeleteSaleItem = createAsyncThunk(
  "saleDetails/DeleteSaleItem",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/sale/item/delete/${id}/`)
    return response.status
  }
);